import APIs from "services/API/index";

export const formItems = [
  {
    name: "first_name",
    type: "text",
    label: "First Name",
    values: null,
    required: true,
  },
  {
    name: "last_name",
    type: "text",
    label: "Last Name",
    values: null,
    required: true,
  },
  {
    name: "mobile",
    type: "text",
    label: "Mobile",
    values: null,
    required: true,
  },
  {
    name: "email",
    type: "text",
    label: "Email",
    values: null,
    required: true,
  },
  {
    name: "role_id",
    type: "select",
    label: "Role",
    schema: { label: "name", value: "id" },
    requestOnMount: true,
    apiAddress: APIs.apiRoleList,
  },
];
